import { IEmployee } from '../../routes/client/structure/employees/types';

export const renderAccessor = <T extends IEmployee>(row: T, accString: keyof T, isEN: boolean): string => {
  let accessorString = row[accString];

  if (isEN) {
    accessorString = row[`${String(accString)}_en`] || accessorString;
  }

  return accessorString;
};

export const renderFullNameTooltip = <T extends IEmployee>(row: T, isEN: boolean): string => {
  const namesBG = {
    first_name: row.first_name,
    middle_name: row.middle_name || '',
    last_name: row.last_name,
  };

  const namesEN = {
    first_name: row.first_name_en || row.first_name,
    middle_name: row.middle_name_en || row.middle_name || '',
    last_name: row.last_name_en || row.last_name,
  };

  const renderNames = () => {
    if (isEN) {
      return `${namesEN.first_name} ${namesEN.middle_name} ${namesEN.last_name}`;
    }
    return `${namesBG.first_name} ${namesBG.middle_name} ${namesBG.last_name}`;
  };

  return [`ID ${row.id || ''} - `, renderNames()].join(' ');
};
